import * as types from '../actions';

export default function reset() {
  return {
    type: types.VIEWER_RESET,
  };
}
